<template>

  <div class="container  container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>



      <div class="handle-box">

        <el-row class="head-search">
          <el-col :span="8">
            <span class="title">端口:</span>
            <!-- 搜索司机名称-->
            <el-radio-group v-model="search_data.port">
              <el-radio label="" border>
                全部
              </el-radio>
              <el-radio v-for="(item, index) in val_port_array" :key="index" :label="String(item.val)" border>
                {{ item.alias }}
              </el-radio>
            </el-radio-group>
          </el-col>

        </el-row>

      </div>

      <div>

        <el-button type="primary" icon="el-icon-search" @click="searchBugLists">搜索</el-button>

        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>

    </el-tabs>



    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->


            <el-form-item label="描述:">
              <span>{{ props.row.description }}</span>
            </el-form-item>



            <el-form-item label="备注:">
              <span>

                {{ props.row.remarks }}

              </span>
            </el-form-item>




          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" min-width="80">
      </el-table-column>

      <el-table-column prop="description" label="bug描述" min-width="200">
      </el-table-column>

      <el-table-column prop="status.alias" label="处理状态" min-width="80">
      </el-table-column>

      <el-table-column prop="port.alias" label="端口" min-width="80">
      </el-table-column>


      <el-table-column prop="time.YmdHis" label="提交时间" min-width="150">
      </el-table-column>

      <el-table-column prop="finish_time.YmdHis" label="处理时间" min-width="150">
      </el-table-column>

      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="bugDetermine_show = !bugDetermine_show; bugDetermine_children = scope.row.bug_code;">

            审核


          </el-button>

        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <bugDetermine :isShow="bugDetermine_show" :data="bugDetermine_children"></bugDetermine>

  </div>

</template>

<script>
  var _this;
  import bugDetermine from './bugDetermine.vue';
  export default {
    components: {
      bugDetermine
    },

    data() {
      return {
        // 选择是否全部推送下拉
        value_all_audience: '',

        bugDetermine_show: false,

        // 子组件的传入数据
        bugDetermine_children: '',

        delDriverSubmit_rules: {
          driver_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },


        // 存放表格数据
        tableData: [],

        // 选项卡默认选中项
        activeName: 'all',

        // 下拉搜索管理状态
        value_status_array: [],

        // 下拉搜索端口
        val_port_array: '',

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          status: '',
          port: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.bugLists();
    },

    methods: {
      searchBugLists() {
        _this.search_data.page = 1;
        _this.bugLists();
      },
      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.bugLists();

      },

      // 搜索司机审核列表
      bugLists() {
        _this.$post(
            "/bug/bugLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = _this.tableData[0].status.select_array;
            _this.val_port_array = _this.tableData[0].port.select_array;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.bugLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>